import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
    FormGroup,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_FAQ_Collection } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
function FAQCollection({
    visible,
    toggle,
    submit,
    locale,
    propertyId,
    id,
    label
}) {

    const [categoryData, setCategoryData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        title: [
            {
                statement: '',
                languageCode: locale,
            },
        ],
        displayOrder: 0,
        status: 'Inactive',
        creator: 'Dashboard'
    });
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${API_FAQ_Collection}/${id}`,
            }).then((res) => {
                if (res.data !== undefined && res.data.id !== undefined) {
                    setCategoryData({
                        ...categoryData,
                        title: res.data.title,
                        status: res.data.status,
                        displayOrder: res.data.displayOrder,
                        creator: 'Dashboard'
                    });
                }
            });
        }
    }, []);


    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === locale);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };
    const handleSave = () => {
        submit(categoryData);
    }
    const handleCategoryTitle = (e) => {

        if (categoryData.title.length > 0) {
            const index = categoryData.title.findIndex(
                (m) => m.languageCode === locale
            );
            if (index === -1) {
                const newStatement = {
                    statement: e.target.value,
                    languageCode: locale,
                };
                setCategoryData({
                    ...categoryData,
                    question: [...categoryData.title, newStatement],
                });
            } else {
                let newArr = [...categoryData.title];
                newArr[index].statement = e.target.value;
                setCategoryData({
                    ...categoryData,
                    title: newArr,
                });
            }
        } else {
            const newStatement = {
                statement: e.target.value,
                languageCode: locale,
            };
            setCategoryData({
                ...categoryData,
                title: [...categoryData.title, newStatement],
            });
        }
    };
    return (
        <Modal isOpen={visible} toggle={() => toggle()}>
            <ModalHeader toggle={() => toggle()}>{label}</ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx sm={12} className="mb-3">
                        <Label>Title<span style={{ color: 'red' }}> *</span></Label>
                        <Input
                            type="text"
                            value={getLocalStatement(categoryData.title)}
                            onChange={handleCategoryTitle}
                            name="title"
                        />
                    </Colxx>
                    <Colxx sm={6} style={{ marginBottom: "10px" }}>
                        <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                        <Input
                            type="number"
                            min={0}
                            name="displayOrder"
                            value={categoryData.displayOrder}
                            onChange={(e) => setCategoryData({ ...categoryData, displayOrder: e.target.value })}
                        />
                    </Colxx>
                    <Colxx sm={6} className="mb-3">
                        <Label>Status<span style={{ color: 'red' }}> *</span></Label>
                        <Input
                            type="select"
                            value={categoryData.status}
                            onChange={(e) => setCategoryData({ ...categoryData, status: e.target.value })}
                            name="status"
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </Input>
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>

                <Button
                    color="primary"
                    onClick={() => handleSave()}
                >
                    Save
                </Button>

                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>
    )
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(FAQCollection));